import styled from 'styled-components'

const EmployeeTimesheetIndSc = styled.div`
  width: 90vw;
  position: absolute;
  top: 55px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  /* CSS for table styling */
  /* CSS for table styling */
  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    background-color: #ffffff;
    margin: 20px 0;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  th,
  td {
    border: 1px solid #dddddd;
    padding: 10px;
    text-align: center;
  }

  th {
    background-color: #f2f2f2;
    font-weight: bold;
    color: #333;
  }

  tr:nth-child(even) {
    background-color: #f5f5f5;
  }

  /* Add hover effect to rows */
  tr:hover {
    background-color: #e0e0e0;
  }

  /* Adjust table header styles */
  th:first-child {
    border-top-left-radius: 5px;
  }

  th:last-child {
    border-top-right-radius: 5px;
  }

  /* Add spacing and alignment to table cells */
  td {
    padding: 10px;
  }

  /* Center-align text in cells */
  td:not(:first-child) {
    text-align: center;
  }
  /* CSS for styling the select and input elements */
  .select-container {
    display: inline-block;
    margin-right: 10px;
  }

  .select-container select {
    width: 200px;
    padding: 2rem;
    font-size: 16px;
    border: 1px solid #ddd;
    border-radius: 5px;
    background-color: #fff;
  }

  .date-input {
    width: 200px;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ddd;
    border-radius: 5px;
    background-color: #fff;
  }

  /* Optionally, you can style the <option> elements inside the <select> */
  .select-container select option {
    font-size: 16px;
    background-color: #fff;
    color: #333;
  }
  .filter_option {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
`
export default EmployeeTimesheetIndSc
